import React, { useEffect, useState } from "react";

const ORB_COUNT = { full: 5, reduced: 3, off: 0 };

export default function AmbientOrbs({ intensity = "full" }) {
  const [paused, setPaused] = useState(() => document.hidden);
  const count = ORB_COUNT[intensity] || 0;

  useEffect(() => {
    const onVis = () => setPaused(document.hidden);
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  if (!count) return null;

  const motion = intensity === "reduced" ? "admin-orbs-static" : "";
  return (
    <div
      className={`admin-orbs ${motion} ${paused ? "admin-orbs-paused" : ""}`}
      aria-hidden="true"
    >
      {Array.from({ length: count }, (_, index) => (
        <span key={index} className={`admin-orb admin-orb-${index + 1}`} />
      ))}
    </div>
  );
}
